import { atom } from 'jotai';
import { AuthState } from '@/entities/auth/model/auth.types';

export const authStateAtom = atom<AuthState>({
  accessToken: null,
  user: null,
  isAuthenticated: false,
});

export const authSyncStateAtom = atom<{
  isLoading: boolean;
  isInitialized: boolean;
}>({
  isLoading: true,
  isInitialized: false,
});
